import {Component} from "@/event/calendar/dom/Component.ts";
import {DaysTimedHeader} from "@/event/calendar/days/DaysTimedHeader.ts";
import {DrawingContext} from "@/event/calendar/dom/DrawingContext.ts";
import {Rect} from "@/event/calendar/Shapes.ts";
import {ScrollComponent} from "@/event/calendar/dom/ScrollComponent.ts";

export class DaysTimedArea extends Component {
	private header: DaysTimedHeader;
	private headerScroll: ScrollComponent;

	private body: ScrollComponent;

	constructor(timedHeader: DaysTimedHeader, timedHeaderScroll: ScrollComponent, timedBody: ScrollComponent) {
		super();
		this.header = timedHeader;
		this.headerScroll = timedHeaderScroll;
		this.body = timedBody;
		this.append(this.headerScroll).append(this.body);
	}

	placeChildren(dc: DrawingContext, cb: Rect) {
		this.headerScroll.x = cb.x;
		this.headerScroll.y = cb.y;
		this.headerScroll.width = this.header.gutterWidth;
		this.headerScroll.height = cb.height;

		this.body.x = cb.x + this.header.gutterWidth;
		this.body.y = cb.y;
		this.body.width = cb.width - this.header.gutterWidth;
		this.body.height = cb.height;
	}
}